import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

var modal = {
    selectors: {
        elements:   '[data-modal]',
        trigger:    '[data-modal-trigger]',
        target:     '[data-modal-target]',
        close:      '[data-modal-close]',
    },
    state: {
        $current: null
    },
    init: function() {
        var self  = this,
        $elements = $( self.selectors.elements );

        $elements.each( function() {
            var $el = $( this ),
            id = $el.attr( 'data-modal' ),
            auto = $el.attr( 'data-modal-auto' );

            if ( typeof auto !== 'undefined' && auto !== false ) {
                var closed = self.getCookie( id + '-modal-closed' );

                if ( closed !== '' ) {
                    return;
                }

                var modal = this.querySelector('.branch-modal__content');
                disableBodyScroll( modal );

                setTimeout( function() {
                    $el.addClass( 'modal-opened' );
                }, 100 );
            }

            $el.on( 'open', function(e) {
                var closed = self.getCookie( id + '-modal-closed' );

                if ( closed !== '' ) {
                    return;
                }

                var modal = this.querySelector('.branch-modal__content');
                disableBodyScroll( modal );

                setTimeout( function() {
                    $el.addClass( 'modal-opened' );
                }, 100 );
            } )

            $el.on( 'click', self.selectors.close, function(e) {
                e.preventDefault();

                var modal = this.querySelector('.branch-modal__content');
                clearAllBodyScrollLocks();

                $el.removeClass( 'modal-opened' );

                setTimeout( function() {
                    clearAllBodyScrollLocks();
                    self.setCookie( id + '-modal-closed', '1', 1 );
                }, 100 );

                return false;
            } );
        } );
    },
    getCookie: function( cname ) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent( document.cookie );
        var ca = decodedCookie.split( ';' );
        for ( var i = 0; i < ca.length; i++ ) {
            var c = ca[ i ];
            while ( c.charAt( 0 ) == ' ' ) {
                c = c.substring( 1 );
            }
            if ( c.indexOf( name ) == 0 ) {
                return c.substring( name.length, c.length );
            }
        }
        return "";
    },
    setCookie: function( cname, cvalue, exdays ) {
        var d = new Date();
        d.setTime( d.getTime() + ( exdays * 24 * 60 * 60 * 1000 ) );
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
}

export { modal };